export const NAMESPACE = 'email-activity';

// CASE MANAGER
// ==========================================================================

export const UPDATE_ACTIVITY_QUERIES = `${NAMESPACE}/UPDATE_ACTIVITY_QUERIES`;
export const SET_EMAIL_ACTIVITIES = `${NAMESPACE}/SET_EMAIL_ACTIVITIES`;
